import type {
  ApiEventId,
  ApiInternshipId,
  ApiJobId,
  ApiVolopId,
} from 'api/types/ApiTypedId';
import { FetchEndpoint } from 'utils/endpoint/FetchEndpoint';
import { keyBy } from 'utils/functional/array/keyBy';

type ApiListingId = ApiJobId | ApiInternshipId | ApiVolopId | ApiEventId;

type ApiResponse = {
  listings: {
    id: ApiListingId;
    applied: boolean;
    saved: boolean;
  }[];
};

export function mapResponse(
  response: ApiResponse,
): Partial<Record<ApiListingId, ApiResponse['listings'][number]>> {
  return keyBy(response.listings, 'id');
}

const endpoint = new FetchEndpoint({
  urlFactory: (_) => '/data/userdashboard/listing-extras',
  optionsFactory: (listingIds: ApiListingId[]) => ({
    method: 'post',
    body: { listingIds },
  }),
  mapResponse,
});

// Exports

export const userDashboardApiHorizonFetchListingExtras =
  endpoint.createIsomorphicFetchFn();
